module.exports = __webpack_public_path__ + "static/img/qipao.4db3cff.png";